<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item>
        <u-editor name="content" v-decorator="['content', { rules: [] }]" />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { requestGet, requestPut } from '@/api/api'
import { UEditor } from '@/components'

const fields = ['content']
export default {
    name: 'ContentForm',
    props: {
        id: {
            type: Number,
            default: null
        },
        type: {
            type: String,
            default: 'add'
        }
    },
    components: {
        UEditor
    },
    data () {
        return {
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.$props.type === 'edit') {
            this.getContent(this.$props.id) // 获取编辑信息
        }
    },
    methods: {
        /**
         * 获取编辑信息
         * id
         * @param
         */
        getContent (id) {
            this.spinning = true
            requestGet('/books/contents/' + id)
                .then(res => {
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2
                        requestPut('/books/contents/' + this.$props.id, values)
                            .then(res => {
                                this.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

</style>
